<template>
    <el-dialog :visible.sync="show" :title="$t('nat.operations.delete.name')" :close-on-click-modal="false"
        :before-close="handleClose" class="del-root">
        <p>{{ $t('nat.speechCraft.deleteSnatRuleTip') }}</p>
        <p>{{ $t('nat.speechCraft.sureDeleteSnatRuleTip') }}</p>
        <div slot="footer" class="dialog-footer">
            <el-button @click="cancelDelete">{{ $t('privateNetInstance.cancel') }}</el-button>
            <el-button @click="sureDelete" type="primary" :loading="sureBtnLoading">{{ $t('privateNetInstance.sure') }}</el-button>
        </div>
    </el-dialog>
</template>


<script>
import { deleteSNatRuleApi } from '@/api/nat/detail/actions';
export default {
    name: 'UnBindEip',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        rowInfo: {
            type: Object,
            default: {}
        },
        region: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            sureBtnLoading: false,
            show: false
        };
    },
    watch: {
        visible(newVal) {
            this.show = newVal;
        }
    },
    methods: {
        handleClose() {
            this.sureBtnLoading = false;
            this.show = false;
            this.$emit('update:visible', false);
        },
        cancelDelete() {
            this.handleClose();
        },
        sureDelete() {
            this.sureBtnLoading = true;
            const params = {
                region: this.region,
                snatRuleId: this.rowInfo.snatRuleId,
            };
            deleteSNatRuleApi(params).then((res) => {
                this.$message.success(this.$t('privateNetInstance.operateSuccess'));
            })
                .catch(async (err) => {
                    const { response } = err.data;
                    try {
                        const json = await response.json();
                        this.$message.error(json.errmsg);
                    } catch (ex) {
                        console.log(ex);
                    }
                })
                .finally(() => {
                    this.handleClose();
                    this.$emit('refresh');
                });

        }
    },
};
</script>

<style scoped lang="scss">
.del-root {
    p {
        text-align: left;
        margin: 12px;
        line-height: 1.5;
        color: #212121;
        word-break: break-all;
        font-size: 14px;
    }
}
</style>





// WEBPACK FOOTER //
// src/components/nat/DeleteSnatRule.vue